import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

interface GuidedHighlightingPostPayload {
  content_id: string;
  start_index: number;
  end_index: number;
  annotation_type?: string;
  metadata: {
    pen_name: string | null;
    text: string;
    reading_skill: string;
    lexile_level: string;
    is_correct: boolean;
    attempt_number: number;
    points: number;
    assignment_id: string;
  };
}

const useGuidedHighlightingPost = () => {
  const createEventRecordRequest = useCallback(
    (payload: GuidedHighlightingPostPayload) => {
      payload.annotation_type = "guided_highlighting";
      const body = payload;

      const requestUrl = `${API_BASE_URL}/api/v3/annotations/`;

      return new Request(requestUrl, {
        method: "POST",
        body: JSON.stringify(body),
        headers: { "Content-Type": "application/json" },
      });
    },
    [],
  );

  return useRestMutation(createEventRecordRequest);
};

export default useGuidedHighlightingPost;
